import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FaComments, FaPhone, FaEnvelope, FaWhatsapp, FaArrowUp, FaTimes, FaMapMarkerAlt} from 'react-icons/fa';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import TermsOfService from './components/Legal/TermsOfService';
import CookieConsent from './components/Legal/CookieConsent';
import './App.css';

function App() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showContactButtons, setShowContactButtons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const toggleContactButtons = () => {
    setShowContactButtons(!showContactButtons);
  };

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Services />
                <Portfolio />
                <About />
                <Contact />
              </>
            } />
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/conditions-generales" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />

        <CookieConsent />

        {/* Bouton de retour en haut */}
        <button
          className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
          onClick={scrollToTop}
          aria-label="Retour en haut"
        >
          <FaArrowUp />
        </button>

        {/* Menu de contact flottant */}
        <div className="floating-contact-container right">
          <div className={`floating-contact-buttons ${showContactButtons ? 'visible' : ''}`}>
            <a href="tel:+243813765290" className="floating-contact-item" aria-label="Appeler" title='Appel'>
              <FaPhone />
            </a>
            <a href="mailto:contact.mulbyte@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="floating-contact-item"
              aria-label="Envoyer un email"
              title='Email'>
              <FaEnvelope />
            </a>
            <a
              href="https://wa.me/message/Q63GCO6ZSZ67O1"
              target="_blank"
              rel="noopener noreferrer"
              className="floating-contact-item"
              aria-label="Chat WhatsApp"
              title='WhatsApp'
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Kinshasa,RDC"
              target="_blank"
              rel="noopener noreferrer"
              className="floating-contact-item"
              title='Maps'
            >
              <FaMapMarkerAlt />
            </a>
          </div>

          <button
            className="floating-contact-main"
            onClick={toggleContactButtons}
            aria-label={showContactButtons ? "Fermer les contacts" : "Ouvrir les contacts"}
          >
            {showContactButtons ? <FaTimes /> : <FaComments />}
          </button>
        </div>
      </div>
    </Router>
  );
}

export default App;